module.exports = __webpack_public_path__ + "img/lavadora.a4bb1dd0.svg";